module.exports = __webpack_public_path__ + "img/icon-refund.72722aa0.svg";